import { Button, Flex, Space, Typography } from 'antd';
import { FC, memo } from 'react';
import { CheckCircle, SlashCircle, Trash } from 'react-bootstrap-icons';

interface Props {
  selectedCount: number;
  totalCount: number;
  isBusy: boolean;
  isUpdatingActivity: boolean;
  onSetActivity: (isActive: boolean) => void;
  onOpenDeleteModal: () => void;
}

export const RedirectsManageToolbar: FC<Props> = memo(({
  selectedCount,
  totalCount,
  isBusy,
  isUpdatingActivity,
  onSetActivity,
  onOpenDeleteModal,
}) => {
  return (
    <Flex justify="space-between" align="center" wrap="wrap" gap={ 8 }>
      <Typography.Text type="secondary">
        Вибрано: <b>{ selectedCount }</b> із { totalCount }
      </Typography.Text>

      <Space>
        <Button
          icon={ <CheckCircle/> }
          disabled={ !selectedCount || isBusy }
          loading={ isUpdatingActivity }
          onClick={ () => onSetActivity(true) }
        >
          Активувати
        </Button>
        <Button
          icon={ <SlashCircle/> }
          disabled={ !selectedCount || isBusy }
          loading={ isUpdatingActivity }
          onClick={ () => onSetActivity(false) }
        >
          Деактивувати
        </Button>
        <Button
          danger
          icon={ <Trash/> }
          disabled={ !selectedCount || isBusy }
          onClick={ onOpenDeleteModal }
        >
          Видалити
        </Button>
      </Space>
    </Flex>
  );
});
